module.exports = __webpack_public_path__ + "static/3-ebc6eed8c5eadb20cefaad95452ff476.jpg";